// redux/sagas/companySaga.js

import { put, call } from "redux-saga/effects";
import { push } from 'react-router-redux';
import Swal from "sweetalert2";

import {
    getCompanySuccess, getCompanyFail,
    getCompanyByCodeSuccess, getCompanyByCodeFail,
    getAllCompaniesSuccess, getAllCompaniesFail,
    createCompanySuccess, createCompanyFail,
    updateCompanySuccess, updateCompanyFail,
    deleteCompanySuccess, deleteCompanyFail,
    setCompanyLoading, setHolidaysLoading, getHolidaysFail, getHolidaysSuccess
} from "../actions/companyactions";

import {
    API_BASE_URL,
    getRequest,
    postRequest,
    putRequest,
    deleteRequest
} from "../../../api";

// GET /api/companies/{id}
export function* getCompanySaga(action) {
    const url = `${API_BASE_URL}/api/companies/${action.payload.companyId}`;
    yield put(setCompanyLoading(true));

    try {
        console.group('🔵 GET_COMPANY_REQUEST');
        console.log('📊 Company ID:', action.payload.companyId);
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group('✅ GET_COMPANY_SUCCESS');
        console.log('📥 Réponse API:', resp.data);
        console.groupEnd();

        yield put(getCompanySuccess(resp.data));
    } catch (error) {
        console.group('❌ GET_COMPANY_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getCompanyFail(error.message));
    } finally {
        yield put(setCompanyLoading(false));
    }
}

// GET /api/companies/code/{code}
export function* getCompanyByCodeSaga(action) {
    const url = `${API_BASE_URL}/api/companies/code/${action.payload.code}`;
    yield put(setCompanyLoading(true));

    try {
        console.group('🔵 GET_COMPANY_BY_CODE_REQUEST');
        console.log('📊 Code:', action.payload.code);
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group('✅ GET_COMPANY_BY_CODE_SUCCESS');
        console.log('📥 Réponse API:', resp.data);
        console.groupEnd();

        yield put(getCompanyByCodeSuccess(resp.data));
    } catch (error) {
        console.group('❌ GET_COMPANY_BY_CODE_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getCompanyByCodeFail(error.message));
    } finally {
        yield put(setCompanyLoading(false));
    }
}

// GET /api/companies
export function* getAllCompaniesSaga() {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/companies`;
    yield put(setCompanyLoading(true));

    try {
        console.group('🔵 GET_ALL_COMPANIES_REQUEST');
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group('✅ GET_ALL_COMPANIES_SUCCESS');
        console.log('📥 Nombre de sociétés:', resp.data.length);
        console.groupEnd();

        yield put(getAllCompaniesSuccess(resp.data));
    } catch (error) {
        console.group('❌ GET_ALL_COMPANIES_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getAllCompaniesFail(error.message));
    } finally {
        yield put(setCompanyLoading(false));
    }
}

// POST /api/companies
export function* createCompanySaga(action) {
    const url = `${API_BASE_URL}/api/companies`;
    const data = action.payload;
    yield put(setCompanyLoading(true));

    try {
        console.group('🔵 CREATE_COMPANY_REQUEST');
        console.log('📊 Données:', data);
        console.groupEnd();

        const resp = yield call(postRequest, { url, data });

        console.group('✅ CREATE_COMPANY_SUCCESS');
        console.log('📥 Société créée:', resp.data);
        console.groupEnd();

        yield put(createCompanySuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: "Société créée avec succès",
            timer: 2000,
            showConfirmButton: false
        });

        if (action.history) {
            yield put(push('/companies'));
        }
    } catch (error) {
        console.group('❌ CREATE_COMPANY_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(createCompanyFail(error.message));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors de la création",
            timer: 2000,
            showConfirmButton: false
        });
    } finally {
        yield put(setCompanyLoading(false));
    }
}

// PUT /api/companies/{id}
export function* updateCompanySaga(action) {
    const url = `${API_BASE_URL}/api/companies/${action.payload.companyId}`;
    const data = action.payload.companyData;
    yield put(setCompanyLoading(true));

    try {
        console.group('🔵 UPDATE_COMPANY_REQUEST');
        console.log('📊 Company ID:', action.payload.companyId);
        console.log('📊 Nouvelles données:', data);
        console.groupEnd();

        const resp = yield call(putRequest, { url, data });

        console.group('✅ UPDATE_COMPANY_SUCCESS');
        console.log('📥 Société mise à jour:', resp.data);
        console.groupEnd();

        yield put(updateCompanySuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: "Société mise à jour avec succès",
            timer: 2000,
            showConfirmButton: false
        });
    } catch (error) {
        console.group('❌ UPDATE_COMPANY_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(updateCompanyFail(error.message));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors de la mise à jour",
            timer: 2000,
            showConfirmButton: false
        });
    } finally {
        yield put(setCompanyLoading(false));
    }
}

// DELETE /api/companies/{id}
export function* deleteCompanySaga(action) {
    const url = `${API_BASE_URL}/api/companies/${action.payload.companyId}`;
    yield put(setCompanyLoading(true));

    try {
        yield call(deleteRequest, { url });

        yield put(deleteCompanySuccess(action.payload.companyId));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: 'Succès',
            text: "Société supprimée avec succès",
            timer: 2000,
            showConfirmButton: false
        });

    } catch (error) {
        console.error('DELETE COMPANY ERROR', error);

        let errorMessage = "Erreur lors de la suppression";

        // ✅ CAS COMME JOBS
        if (error.response?.status === 409) {
            errorMessage =
                error.response?.data?.message ||
                "Cette société est utilisée ailleurs";
        } else if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
        } else if (error.message) {
            errorMessage = error.message;
        }

        yield put(deleteCompanyFail(errorMessage));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: 'Suppression impossible',
            text: errorMessage,
            confirmButtonText: 'OK',
            confirmButtonColor: '#d33'
        });
    } finally {
        yield put(setCompanyLoading(false));
    }
}

export function* getHolidaysSaga(action) {
    const { year, country } = action.payload;
    const url = `${API_BASE_URL}/api/companies/holidays/${year}?country=${country}`;
    yield put(setHolidaysLoading(true));

    try {
        console.group("🔵 GET_HOLIDAYS_REQUEST");
        console.log("📅 Year:", year, "Country:", country);
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group("✅ GET_HOLIDAYS_SUCCESS");
        console.log("📥 Holidays:", resp.data?.length);
        console.groupEnd();

        yield put(getHolidaysSuccess(resp.data));
    } catch (error) {
        console.group("❌ GET_HOLIDAYS_FAIL");
        console.error("🚨 Error:", error.message);
        console.groupEnd();

        yield put(getHolidaysFail(error.message));
    } finally {
        yield put(setHolidaysLoading(false));
    }
    }
